/**
 * Created by spepa on 05.03.2024
 */

cc.TargetedAction = function (target, action) {
    cc.ActionInterval.prototype.constructor.call(this);

    this._action = undefined;
    this._forcedTarget = undefined;

    if (action && action._duration === 0) {
        cleverapps.throwAsync("TargetedAction with ActionInstant performs twice!");
    }

    if (action !== undefined) {
        this.initWithTarget(target, action);
    }

    this._stack = new Error();
};

cc.TargetedAction.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: cc.TargetedAction,

    initWithTarget: function (target, action) {
        if (this.initWithDuration(action._duration)) {
            this._forcedTarget = target;
            this._action = action;
            return true;
        }
        return false;
    },

    startWithTarget: function (target) {
        cc.ActionInterval.prototype.startWithTarget.call(this, target);
        this._action.startWithTarget(this._forcedTarget);
    },

    stop: function () {
        this._action.stop();
    },

    update: function (dt) {
        if (!this._forcedTarget.isRunning()) {
            if (!this._thrown) {
                this._thrown = true;
                cleverapps.throwAsync("target is not running", this._stack);
            }
            return;
        }

        dt = this._computeEaseTime(dt);
        this._action.update(dt);
    }
});

cc.targetedAction = (target, action) => new cc.TargetedAction(target, action);
